<template>
  <div class="w-full">
    <section class="p-12 space-y-8">
      <header class="space-y-2">
        <BaseButton small primary outline @click="$emit('back')">Back</BaseButton>
        <h3 class="text-lg font-medium">Membership product builder</h3>
      </header>
      <div>
        <BaseFetchData :action="fetchData">
          <template #default="fetchDataProps">
            <ProductFeaturesManager
              v-if="fetchDataProps.status.resolved"
              :feature-options="featureOptions"
              v-model="productData.feature_options"
            />
          </template>
        </BaseFetchData>
      </div>
      <BaseVeeForm :action="submit">
        <!-- formProps
          isIdle, isPending, isResolved, isRejected, invalid
          errors, submit, hasServerErrors, getServerErrorMessages
        -->
        <template #default="formProps">
          <div
            v-if="formProps.hasServerErrors"
            class="rounded-md bg-red-50 p-4 text-sm text-red-700 mb-8"
          >
            <ul role="list" class="list-disc space-y-1 pl-5">
              <li v-for="(msg, msgIdx) in formProps.getServerErrorMessages()" :key="msgIdx">
                {{ msg }}
              </li>
            </ul>
          </div>
          <BaseButton primary :disabled="formProps.isPending || formProps.invalid"
            >Create and Add product</BaseButton
          >
        </template>
      </BaseVeeForm>
    </section>
  </div>
</template>

<script>
import { featuresClient, customMembershipProductsClient } from '@/api/clients';
import ProductFeaturesManager from '@/components/ProductFeaturesManager/ProductFeaturesManager.vue';

export default {
  components: {
    ProductFeaturesManager,
  },
  data() {
    return {
      featureOptions: [],
      productData: {
        feature_options: [],
      },
    };
  },
  methods: {
    fetchData() {
      return featuresClient
        .list({
          include: ['options'],
        })
        .then((response) => {
          this.featureOptions = response.data;
        });
    },
    submit() {
      return customMembershipProductsClient.store(this.productData).then((response) => {
        this.$emit('select', response.data);
      });
    },
  },
};
</script>
